/** Phân bổ lần lượt theo thứ tự chọn, không vượt công nợ từng dịch vụ hoặc số dư cọc. */
export const buildAutomaticDepositAllocations = (customerServiceIds, services, availableBalance) => {
    let remainingBalance = Math.max(0, Math.round(Number(availableBalance) || 0));
    const serviceMap = (services || []).reduce((result, service) => ({
        ...result,
        [Number(service.id)]: Math.max(0, Math.round(Number(service.outstanding_amount) || 0)),
    }), {});
    return (customerServiceIds || []).reduce((result, customerServiceId) => {
        const outstandingAmount = serviceMap[Number(customerServiceId)] || 0;
        const amount = Math.min(outstandingAmount, remainingBalance);
        remainingBalance -= amount;
        result[customerServiceId] = amount;
        return result;
    }, {});
};

export const buildDepositAllocationPayload = (customerServiceIds, allocationAmounts) =>
    (customerServiceIds || []).map(customerServiceId => ({
        customer_service_id: customerServiceId,
        amount: allocationAmounts?.[customerServiceId],
    })).filter(item => Number(item.amount) > 0);

export const getDepositAllocationError = ({ value, outstandingAmount, allocationAmounts,
    customerServiceIds, customerServiceId, availableBalance }) => {
    if (Number(value) < 0) return 'Số tiền phân bổ không được âm.';
    if (Number(value) > Number(outstandingAmount || 0)) return 'Số tiền phân bổ vượt công nợ còn lại của dịch vụ.';
    const total = (customerServiceIds || []).reduce((sum, id) => sum + Number(
        Number(id) === Number(customerServiceId) ? value : allocationAmounts?.[id] || 0
    ), 0);
    return total > Number(availableBalance || 0) ? 'Tổng phân bổ vượt số dư cọc.' : null;
};

/** Giới hạn cọc còn có thể dùng trong Phiếu thu sau các nguồn thanh toán khác. */
export const getReceiptDepositLimit = (items, depositBalance, paidAmount, balanceAmount, discountAmount) => {
    const serviceDebt = (items || []).filter(item => item.type === 'Dịch vụ' && item.customer_service_id)
        .reduce((sum, item) => sum + Math.max(0, Number(item.amount) || 0), 0);
    const remainingDebt = Math.max(0, Math.round(serviceDebt - Number(paidAmount || 0)
        - Number(balanceAmount || 0) - Number(discountAmount || 0)));
    return Math.min(Math.max(0, Math.round(Number(depositBalance) || 0)), remainingDebt);
};

/** Tổng số dư khả dụng của các khoản cọc đang chọn, không tính trùng id. */
export const getSelectedDepositBalance = (depositIds, deposits) => {
    const selectedIds = new Set((depositIds || []).map(Number));
    return (deposits || []).reduce((sum, deposit) => selectedIds.has(Number(deposit.id))
        ? sum + Math.max(0, Math.round(Number(deposit.current_balance) || 0)) : sum, 0);
};

/** Tổng tiền hoàn khai báo trên đúng các khoản cọc đang chọn. */
export const selectedDepositRefundTotal = (ids = [], amounts = {}) => ids.reduce(
    (sum, id) => sum + Math.max(0, Number(amounts[id] || 0)), 0
);
